// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_74-3";
export var contentContainer = "_74-0";
export var editorContainer = "_74-1";
export var quillInputForm = "_74-2";
export var zoneDivider = "_74-4";